module.exports = __webpack_public_path__ + "img/N1M8_new.c8004e2f.jpg";